import { useState } from "react";
import { config } from "../services/runtimeConfig";
import styles from "./LoginScreen.module.css";

/**
 * "Tell me when the full site is live" (#526). For visitors with no
 * account: email only, one purpose, stated here. Uses plain fetch, not
 * apiClient, which attaches a token and logs the user out on a 401.
 * The hidden "website" field is a bot trap; people never see it.
 */
export function NotifyMeForm() {
  const [email, setEmail] = useState("");
  const [trap, setTrap] = useState("");
  const [state, setState] = useState("idle"); // idle | sending | done | error
  const [message, setMessage] = useState("");

  async function submit(e) {
    e.preventDefault();
    setState("sending");
    try {
      const res = await fetch(`${config.apiBaseUrl}/notify-me`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, website: trap }),
      });
      const data = await res.json().catch(() => ({}));
      setMessage(data.message || "");
      setState(res.ok ? "done" : "error");
    } catch {
      setMessage("Could not reach the server. Please try again.");
      setState("error");
    }
  }

  if (state === "done") {
    return <p className={styles.notifyDone} role="status">{message}</p>;
  }
  return (
    <form className={styles.notify} onSubmit={submit}>
      <label htmlFor="notify-email">Want to hear when the full site is live?</label>
      <input
        id="notify-email"
        name="email"
        type="email"
        autoComplete="email"
        placeholder="you@example.com"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
      />
      <input
        id="notify-website"
        name="website"
        type="text"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        className={styles.visuallyHidden}
        value={trap}
        onChange={(e) => setTrap(e.target.value)}
      />
      <button type="submit" disabled={state === "sending"}>Notify me</button>
      <p className={styles.passwordHint}>
        We will email you once, when the site launches, and nothing else. Every
        email has an unsubscribe link.
      </p>
      {state === "error" ? <p role="alert">{message || "Something went wrong."}</p> : null}
    </form>
  );
}
